import React, { useEffect, useState } from "react";
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { useDispatch,useSelector } from "react-redux";
import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField";
import GalleryVideoField from "../../components/videoGallery/GalleryPickerField.js";
import VideoGalleryfeild from "../../components/MinistryVideo/GalleryPickerField.js"
import { deleteCampusTimeRequest } from "../../store/Service/servicesActions";
import {AllServicesHooks} from "./hooks/serviceHooks"
import {
  weekDays,
  meetingTimes,
  fetchCampuses,
  handleAddCampus,
  handleRemoveCampus,
  handleSaveService,
  handleGallerySelect
} from "./hooks/serviceHooks.js";
import ReactQuill from "react-quill";
const ServicesField = ({ church, rowData, onClose }) => {
  const dispatch = useDispatch();
  const currentUrl = window.location.href;

      const [serviceName, setServiceName] = useState(rowData?.serviceName || "");
  const [serviceDescription, setServiceDescription] = useState(rowData?.serviceTitle || "");
  const [typeofService, setTypeofService] = useState(rowData?.typeofService || "services");
  const [selectedCampusIndex, setSelectedCampusIndex] = useState(null);
  const existingVideos = rowData?.servicevideos || [];

  const [campusSchedules, setCampusSchedules] = useState({
    campusId: "",
    day: "",
    startfrom: "",
    endsat: "",
    repeat: "weekly",
  });
  const [savedCampuses, setSavedCampuses] = useState(rowData?.campusesandtime || []);
  const [coverGalleryRaw, setCoverGalleryRaw] = useState(null);
  const [galleryData, setGalleryData] = useState(rowData?.servicegallery?.[0] || {});
  const [tempUrls, setTempUrls] = useState({ web: "", tablet: "", mobile: "" });
  const [campusOptions, setCampusOptions] = useState([]);
  const churches = useSelector((state) => state.churches.churches);
  const [formKey, setFormKey] = useState(0);
  const handleThumbSelect = (img) => {

    const selectedVideos = img?.target?.value || [];

    if (!Array.isArray(selectedVideos) || selectedVideos.length === 0) {
      setThumbnailImage([]);
      return;
    }


    // Check which videos already exist in service
    const existingVideos = rowData?.servicevideos || [];

    // Extract IDs of existing videos
    const existingVideoIds = existingVideos.map(video =>
      video.videoObjId ||
      video.id ||
      video.video?._id ||
      video.video?.id ||
      video.fullItem?._id ||
      video.fullItem?.id
    ).filter(id => id); // Remove undefined/null


    // Filter out videos that already exist
    const newVideos = selectedVideos.filter(video => {
      const videoId = video.id || video._id;
      const isNew = !existingVideoIds.includes(videoId);
            return isNew;
    });


    // Extract IDs of new videos
    const newVideoIds = newVideos.map(video => video.id || video._id);

    if (newVideos.length > 0) {
      setThumbnailImage(newVideoIds); // Now store array of IDs
      toast.success(`${newVideos.length} new video(s) selected`);
    } else {
      setThumbnailImage([]);
      toast.info("All selected videos already exist for this service");
    }
  };
  const [thumbnailImage, setThumbnailImage] = useState([]);
  const [isLive,setIslive] =useState(false)
  const [isDefault,setIsDefault] =useState(false)
  useEffect(() => {
    if (church?._id && Array.isArray(churches) && churches.length > 0) {
      const campuses = fetchCampuses(churches, church._id);
      setCampusOptions(campuses);
    }
  }, [church?._id, churches]);



  const isEmpty = (val) =>
    val === undefined || val === null || val.toString().trim() === "";

  const stripHtml = (html) =>
    html?.replace(/<(.|\n)*?>/g, "").trim();
  const validateServiceFields = () => {
    if (!church?._id) {
      toast.error("Church is required");
      return false;
    }

    if (isEmpty(typeofService)) {
      toast.error("Service Type is required");
      return false;
    }

    if (isEmpty(serviceName)) {
      toast.error("Service Name is required");
      return false;
    }

    if (isEmpty(stripHtml(serviceDescription))) {
      toast.error("Service Title is required");
      return false;
    }

    // Campus validation
    if (!Array.isArray(savedCampuses) || savedCampuses.length === 0) {
      toast.error("Please add at least one campus schedule");
      return false;
    }

    const invalidCampus = savedCampuses.find(
      (c) =>
        !c.campusId ||
        !c.day ||
        !c.startfrom ||
        !c.endsat
    );

    if (invalidCampus) {
      toast.error("All campus schedule fields are mandatory");
      return false;
    }

    // Cover Image (only for ADD, not required for UPDATE)
    // if (!rowData && !coverGalleryRaw) {
    //   toast.error("Cover Image is required");
    //   return false;
    // }

    // Service Gallery (only for ADD, not required for UPDATE)
    if (!rowData && !galleryData?.galleryObjId && !tempUrls?.web) {
      toast.error("Service Gallery is required");
      return false;
    }

    // Video selection - for UPDATE, check if either we have existing videos OR new video selected
    const hasExistingVideos = rowData?.servicevideos && rowData.servicevideos.length > 0;
  const hasNewVideos = Array.isArray(thumbnailImage) && thumbnailImage.length > 0;

  if (!hasNewVideos && !hasExistingVideos) {
    toast.error("Please select at least one video");
    return false;
  }

    return true;
  };
  const [apiService, setApiService] = useState(null);
  const {fetchAllServices} = AllServicesHooks();
  useEffect(() => {
    if (!rowData?.serviceObjId || !church?._id) return;

    fetchAllServices(
      dispatch,
      1,
      100,
      {},
      (res) => {
        if (!res?.data?.length) return;

        const service = res.data.find(
          (s) => s.serviceObjId === rowData.serviceObjId
        );

        if (service) {
          setApiService(service);
        }
      },
      church._id
    );
  }, [rowData?.serviceObjId, church?._id]);
  useEffect(() => {
    if (!apiService || campusOptions.length === 0) return;

    // 1️⃣ Primary fields
    setServiceName(apiService.serviceName || "");
    setServiceDescription(apiService.serviceTitle || "");
    setTypeofService(apiService.typeofService || "services");

    // 2️⃣ Campus schedules
    const mappedCampuses = (apiService.campusesandtime || []).map((campus) => {
      const match = campusOptions.find(
        (opt) => opt._id === campus.campusreffObjId
      );

      return {
        campusId: campus.campusreffObjId,
        campusandtimeObjId: campus.campusandtimeObjId,
        campusName: match?.name || "Unknown Campus",
        day: campus.day,
        startfrom: campus.startfrom,
        endsat: campus.endsat,
        repeat: campus.repeat,
      };
    });

    setSavedCampuses(mappedCampuses);

    if (mappedCampuses.length > 0) {
      const c = mappedCampuses[0];
      setCampusSchedules({
        campusId: c.campusId,
        day: c.day,
        startfrom: c.startfrom,
        endsat: c.endsat,
        repeat: c.repeat,
      });
    }

    // 3️⃣ Gallery
    if (apiService.servicegallery?.length > 0) {
      const gallery = apiService.servicegallery[0];
      setGalleryData(gallery);

      setTempUrls({
        web: gallery.web?.url || "",
        tablet: gallery.tablet?.url || "",
        mobile: gallery.mobile?.url || "",
      });
    }

    // 4️⃣ Videos
    if (apiService.servicevideos?.length > 0) {
      const videoIds = apiService.servicevideos
        .map(v => v.videoObjId || v.id)
        .filter(Boolean);

      setThumbnailImage(videoIds);

      setIslive(apiService.servicevideos[0]?.live || false);
      setIsDefault(apiService.servicevideos[0]?.default || false);
    } else {
      setThumbnailImage([]);
    }
  }, [apiService, campusOptions]);
  const cleanHtmlContent = (htmlContent) => {
    if (!htmlContent) return htmlContent;

    // Remove ALL color-related styles and formatting
    return htmlContent
      // Remove background-color styles
      .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
      // Remove color styles
      .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
      // Remove any style attribute that contains color (more comprehensive)
      .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
      // Remove any style attributes with single quotes
      .replace(/style='[^']*'/gi, '')
      // Remove empty style attributes
      .replace(/style=""/gi, '')
      // Remove any span tags that might have had styling (keeps span but removes all styles)
      .replace(/<span[^>]*>/gi, '<span>')
      // Remove any font tags that might bring color
      .replace(/<font[^>]*>/gi, '')
      .replace(/<\/font>/gi, '')
      // Also remove any color-related CSS classes
      .replace(/class="[^"]*color[^"]*"/gi, '');
  };
  return (
    <>
    <div className="px-4 text-white space-y-8">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      {/* Save Button */}
      <div className="flex justify-end">
        <button
          className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
          onClick={() => {
            if (!validateServiceFields()) return;

            handleSaveService({
              dispatch,
              church,
              serviceName,
              serviceDescription,
              typeofService,
              savedCampuses,
              setServiceName,
              setServiceDescription,
              setTypeofService,
              setSavedCampuses,
              galleryData,
              onClose,
              rowData,
              setFormKey,
              thumbnailImage,
              isLive,
              isDefault,
              existingVideos
            });
          }}

        >
          Save Service
        </button>
      </div>

      {/* Type */}
      <div>
        <label className="text-sm text-greyish font-medium">Type</label>
        <select
          value={typeofService}
          onChange={(e) => setTypeofService(e.target.value)}
          className="bg-blackish p-2 w-full text-white rounded-md h-10 mt-2"
        >
          <option value="services">Services</option>
          <option value="ministry">Ministry</option>
        </select>
      </div>

      {/* Service Name */}
      <div>
        <label className="text-sm text-greyish font-medium">Service Name</label>
        <input
          type="text"
          value={serviceName}
          onChange={(e) => setServiceName(e.target.value)}
          className="bg-blackish p-2 w-full text-white rounded-md h-10 mt-2"
          placeholder="Enter Service Name"
        />
      </div>

      {/* Description */}
    {/* Description */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Service Title
  </label>

  <div className="mt-2">
    <ReactQuill
      value={serviceDescription}
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setServiceDescription(cleanedValue);
      }}
      theme="snow"
      placeholder="Enter Service Title"
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>
</div>


      {/* Cover Gallery */}
      {/* <GalleryPickerField
        label="Cover Image"
        name="coverGallery"
        church={church}
        value={""}
        handleChange={setCoverGalleryRaw}
      /> */}

      {/* Campus Schedules */}
      <div className="space-y-6 border-t border-gray-700 pt-4">
        <div className="space-y-3 border-b border-gray-700 pb-4">
          <select
            className="bg-blackish p-2 text-white rounded-md h-10 w-full"
            value={campusSchedules.campusId}
            onChange={(e) => setCampusSchedules({ ...campusSchedules, campusId: e.target.value })}
          >
            <option value="">Select Campus</option>
            {campusOptions.map(c => (
              <option key={c._id} value={c._id}>{c.name}</option>
            ))}
          </select>

          <div className="text-sm text-greyish mb-1">Week Day</div>
          <div className="flex gap-3 flex-wrap">
            {weekDays.map((day) => (
              <label key={day} className="flex items-center gap-1 text-white cursor-pointer">
                <input
                  type="radio"
                  name="selectedDay"
                  checked={campusSchedules.day === day}
                  onChange={() => setCampusSchedules({ ...campusSchedules, day })}
                  className="w-4 h-4 accent-yellowish"
                />
                {day}
              </label>
            ))}
          </div>

          <div>
            <div className="text-sm text-greyish mb-1">Repeat On</div>
            <select
              className="bg-blackish p-2 text-white rounded-md h-10 w-full"
              value={campusSchedules.repeat}
              onChange={(e) => setCampusSchedules({ ...campusSchedules, repeat: e.target.value })}
            >
              <option value="bi-weekly">Bi-weekly</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>

          <div>
            <div className="text-sm text-greyish mb-1">Start Time</div>
            <select
              className="bg-blackish p-2 text-white rounded-md h-10 w-full"
              value={campusSchedules.startfrom}
              onChange={(e) => setCampusSchedules({ ...campusSchedules, startfrom: e.target.value })}
            >
              <option value="">Select Start Time</option>
              {meetingTimes.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div>
            <div className="text-sm text-greyish mb-1">End Time</div>
            <select
              className="bg-blackish p-2 text-white rounded-md h-10 w-full"
              value={campusSchedules.endsat}
              onChange={(e) => setCampusSchedules({ ...campusSchedules, endsat: e.target.value })}
            >
              <option value="">Select End Time</option>
              {meetingTimes.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
        </div>

        <button
  className="flex items-center gap-2 text-yellowish"
  onClick={() => {
    if (!campusSchedules.campusId || !campusSchedules.day || !campusSchedules.startfrom || !campusSchedules.endsat) {
      return toast.error("Please fill all campus schedule fields");
    }

    if (selectedCampusIndex !== null) {
      // UPDATE EXISTING CAMPUS
      const updated = [...savedCampuses];
      updated[selectedCampusIndex] = {
        ...updated[selectedCampusIndex],
        ...campusSchedules,
        campusName: campusOptions.find(x => x._id === campusSchedules.campusId)?.name || "Unknown"
      };
      setSavedCampuses(updated);
      setSelectedCampusIndex(null);
    } else {
      // ADD NEW CAMPUS
      handleAddCampus({ campusSchedules, setSavedCampuses, setCampusSchedules, campusOptions });
    }

    // RESET FORM
    setCampusSchedules({
      campusId: "",
      day: "",
      startfrom: "",
      endsat: "",
      repeat: "weekly",
    });
  }}
>
  <AiOutlinePlus /> {selectedCampusIndex !== null ? "Update Campus" : "Add Campus"}
</button>


        {savedCampuses.length > 0 && (
  <div className="flex flex-wrap gap-2">
    {savedCampuses.map((c, idx) => (
      <div
        key={idx}
        className={`px-3 py-1 flex items-center gap-2 rounded-full relative group cursor-pointer
                   ${selectedCampusIndex === idx ? "bg-white text-black" : "bg-yellowish text-black"}`}
        onClick={() => {
          setSelectedCampusIndex(idx); // select pill
          setCampusSchedules({
            campusId: c.campusId,
            day: c.day,
            startfrom: c.startfrom,
            endsat: c.endsat,
            repeat: c.repeat,
          });
        }}
      >
        {c.campusName}
        <AiOutlineClose
  size={14}
  onClick={(e) => {
    e.stopPropagation();

    const campus = savedCampuses[idx];

    // ❗ If campus exists only locally (not saved in DB yet)
    if (!campus.campusandtimeObjId) {
      handleRemoveCampus(idx, setSavedCampuses);
      if (selectedCampusIndex === idx) setSelectedCampusIndex(null);
      return;
    }

    // ❗ If campus is saved: Call API delete
    dispatch(deleteCampusTimeRequest(
      {
        _id: church?._id,                               // Church Obj ID
        serviceObjId: rowData?.serviceObjId,           // Service Obj ID
        campusandtimeObjId: campus.campusandtimeObjId, // Campus & time Obj ID
      },
      (res) => {
        if (res.type === 1) {
          toast.success("Campus deleted successfully");

          // Remove from UI
          handleRemoveCampus(idx, setSavedCampuses);
          if (selectedCampusIndex === idx) setSelectedCampusIndex(null);
        } else {
          toast.error("Failed to delete campus");
        }
      }
    ));
  }}
/>

        <div className="absolute  top-10 left-3/4 -translate-x-1/2 bg-blackish text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap z-10">
          {c.day} @ {c.startfrom} - {c.endsat} ({c.repeat})
        </div>
      </div>
    ))}
  </div>
)}

      </div>

      {/* Service Gallery */}
      <GalleryPickerField
  key={formKey}   // 🔥 forces component reset

        label="Service Gallery"
        name="galleryImage"
        church={church}
        rowData={rowData}
        value=""
        handleChange={(imageSet) =>
          handleGallerySelect({ imageSet, setTempUrls, setGalleryData , existingGallery: rowData?.servicegallery || [] // Pass existing gallery
          })
        }
      />
      {
currentUrl.toLowerCase().includes("addministryfield")?


<VideoGalleryfeild
        label="Select Video"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
        rowData={rowData}

      />
      :
      <GalleryVideoField
        label="Select Video"
        name="thumbnail"
        church={church}
        rowData={rowData}
        handleChange={handleThumbSelect}
        initialSelectedVideoId={rowData?.servicevideos?.[0]?.videoObjId} // Add this prop

      />
}
               <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div>
    </div>
    </>
  );
};

export default ServicesField;
